<template>
  <div>
    <v-card class="px-10" flat>
      <div class="d-flex text-center align-center">
        <span class="mx-5"> 1.</span>
        <v-select
          :items="items1"
          item-text="Title"
          item-value="Id"
          label="Position 1"
          attach
          v-model="FBlog1"
          @change="SetB1"
          :error-messages="
                $v.FBlog1.$error ? 'FBlog1 field is required' : null
              "
        ></v-select>
        <v-icon @click="Unselect('1')">mdi-close</v-icon>
      </div>
      <div class="d-flex text-center align-center">
        <span class="mx-5"> 2.</span>
        <v-select
          :items="items2"
          item-text="Title"
          item-value="Id"
          label="Position 2"
          attach
          v-model="FBlog2"
          @change="SetB1"
          :error-messages="
                $v.FBlog2.$error ? 'FBlog2 field is required' : null
              "
        ></v-select>
        <v-icon @click="Unselect('2')">mdi-close</v-icon>
      </div>
      <div class="d-flex text-center align-center">
        <span class="mx-5"> 3.</span>
        <v-select
          :items="items3"
          item-text="Title"
          item-value="Id"
          label="Position 3"
          attach
          v-model="FBlog3"
          @change="SetB1"
          :error-messages="
                $v.FBlog3.$error ? 'FBlog3 field is required' : null
              "
        ></v-select>
        <v-icon @click="Unselect('3')">mdi-close</v-icon>
      </div>
      <div class="d-flex text-center align-center">
        <span class="mx-5"> 4.</span>
        <v-select
          :items="items4"
          item-text="Title"
          item-value="Id"
          label="Position 4"
          attach
          v-model="FBlog4"
          @change="SetB1"
          :error-messages="
                $v.FBlog4.$error ? 'FBlog4 field is required' : null
              "
        ></v-select>
        <v-icon @click="Unselect('4')">mdi-close</v-icon>
      </div>
      <div class="d-flex text-center align-center">
        <span class="mx-5"> 5.</span>
        <v-select
          :items="items5"
          item-text="Title"
          item-value="Id"
          label="Position 5"
          attach
          v-model="FBlog5"
          @change="SetB1"
          :error-messages="
                $v.FBlog5.$error ? 'FBlog5 field is required' : null
              "
        ></v-select>
        <v-icon @click="Unselect('5')">mdi-close</v-icon>
      </div>
      <div
        class="d-flex text-center align-center"
        style="justify-content: space-between"
      >
        <span class="mx-5"> 6.</span>
        <v-select
          :items="items6"
          item-text="Title"
          item-value="Id"
          label="Position 6"
          attach
          v-model="FBlog6"
          @change="SetB1"
          :error-messages="
                $v.FBlog6.$error ? 'FBlog6 field is required' : null
              "
        >
        </v-select>
        <v-icon @click="Unselect('6')">mdi-close</v-icon>
      </div>
    </v-card>
    <v-card-actions class="px-8 pb-7">
      <v-spacer></v-spacer>
      <v-btn
        color="grey lighten-1"
        text
        class="text_style mx-5"
        @click="CloseOrganizeBlogs"
      >
        Cancel
      </v-btn>
      <v-btn color="primary" class="text_style px-14" depressed :disabled="btnloader" @click="send()">
        <span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          v-else
          indeterminate
          size="20"
          class="px-5"
          color="white "
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  name: "organizeblog1component",
  mixins: [validationMixin],
  validations: {
    FBlog1: { required },
    FBlog2: { required },
    FBlog3: { required },
    FBlog4: { required },
    FBlog5: { required },
    FBlog6: { required },
  },
  data() {
    return {
      FBlog1: "",
      FBlog2: "",
      FBlog3: "",
      FBlog4: "",
      FBlog5: "",
      FBlog6: "",
      items1: [],
      items2: [],
      items3: [],
      items4: [],
      items5: [],
      items6: [],
      btnloader: false,
    };
  },
  computed: {
    ...mapGetters(["OrganizeGetBlogs","GetFeaturedBlogs"]),
  },
   mounted() {
    
     this.$store.dispatch("GetFeaturedBlogs").then((res) => {
      console.log("aaaaaaa ",res)
      this.FBlog1 =
        res.filter((x) => x.Position == 1)[0] != undefined
          ? res.filter((x) => x.Position == 1)[0].BlogId
          : "";
      this.FBlog2 =
        res.filter((x) => x.Position == 2)[0] != undefined
          ? res.filter((x) => x.Position == 2)[0].BlogId
          : "";
      this.FBlog3 =
        res.filter((x) => x.Position == 3)[0] != undefined
          ? res.filter((x) => x.Position == 3)[0].BlogId
          : "";
      this.FBlog4 =
        res.filter((x) => x.Position == 4)[0] != undefined
          ? res.filter((x) => x.Position == 4)[0].BlogId
          : "";
      this.FBlog5 =
        res.filter((x) => x.Position == 5)[0] != undefined
          ? res.filter((x) => x.Position == 5)[0].BlogId
          : "";
      this.FBlog6 =
        res.filter((x) => x.Position == 6)[0] != undefined
          ? res.filter((x) => x.Position == 6)[0].BlogId
          : "";
      this.SetItems();
      this.SetB1();
    });
  },
  methods: {
    Unselect(i) {
      if (i == "1") {
        this.FBlog1 = "";
        this.SetB1();
      }
      if (i == "2") {
        this.FBlog2 = "";
        this.SetB1();
      }
      if (i == "3") {
        this.FBlog3 = "";
        this.SetB1();
      }
      if (i == "4") {
        this.FBlog4 = "";
        this.SetB1();
      }
      if (i == "5") {
        this.FBlog5 = "";
        this.SetB1();
      }
      if (i == "6") {
        this.FBlog6 = "";
        this.SetB1();
      }
    },
    CloseOrganizeBlogs() {
      this.$emit("CloseOrganizeBlogs");
      this.snackbar = true;
    },

    send() {
      this.$v.FBlog1.$touch()
      this.$v.FBlog2.$touch()
      this.$v.FBlog3.$touch()
      this.$v.FBlog4.$touch()
      this.$v.FBlog5.$touch()
      this.$v.FBlog6.$touch()
      if(this.$v.FBlog1.$invalid || this.$v.FBlog2.$invalid || this.$v.FBlog3.$invalid || this.$v.FBlog4.$invalid || this.$v.FBlog5.$invalid || this.$v.FBlog6.$invalid){
        return
      }
      this.snackbar = true;
      this.btnloader = true;
      setTimeout(() => {
        this.CloseOrganizeBlogs();
        this.btnloader = false;
      }, 1000);
      var List = [];
      var obj = {
        Id: 0,
        BlogId: 0,
        Position: 0,
      };
      if (this.FBlog1 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog1,
          Position: 1,
        };
        List.push(obj);
      }
      if (this.FBlog2 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog2,
          Position: 2,
        };
        List.push(obj);
      }
      if (this.FBlog3 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog3,
          Position: 3,
        };
        List.push(obj);
      }
      if (this.FBlog4 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog4,
          Position: 4,
        };
        List.push(obj);
      }
      if (this.FBlog5 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog5,
          Position: 5,
        };
        List.push(obj);
      }
      if (this.FBlog6 != "") {
        obj = {
          Id: 0,
          BlogId: this.FBlog6,
          Position: 6,
        };
        List.push(obj);
      }
      this.$store.dispatch("FeatureBlogs", List);
    },
    SetItems() {
  let visibleItems = this.OrganizeGetBlogs.filter(item => item.Visibility === true);
  this.items1 = visibleItems;
  this.items2 = visibleItems;
  this.items3 = visibleItems;
  this.items4 = visibleItems;
  this.items5 = visibleItems;
  this.items6 = visibleItems;
},

    SetB1() {
      this.SetItems();
      if (this.FBlog1 != "") {
        this.items2 = this.items2.filter((x) => x.Id != this.FBlog1);
        this.items3 = this.items3.filter((x) => x.Id != this.FBlog1);
        this.items4 = this.items4.filter((x) => x.Id != this.FBlog1);
        this.items5 = this.items5.filter((x) => x.Id != this.FBlog1);
        this.items6 = this.items6.filter((x) => x.Id != this.FBlog1);
      }
      if (this.FBlog2 != "") {
        this.items1 = this.items1.filter((x) => x.Id != this.FBlog2);
        this.items3 = this.items3.filter((x) => x.Id != this.FBlog2);
        this.items4 = this.items4.filter((x) => x.Id != this.FBlog2);
        this.items5 = this.items5.filter((x) => x.Id != this.FBlog2);
        this.items6 = this.items6.filter((x) => x.Id != this.FBlog2);
      }
      if (this.FBlog3 != "") {
        this.items1 = this.items1.filter((x) => x.Id != this.FBlog3);
        this.items2 = this.items2.filter((x) => x.Id != this.FBlog3);
        this.items4 = this.items4.filter((x) => x.Id != this.FBlog3);
        this.items5 = this.items5.filter((x) => x.Id != this.FBlog3);
        this.items6 = this.items6.filter((x) => x.Id != this.FBlog3);
      }
      if (this.FBlog4 != "") {
        this.items1 = this.items1.filter((x) => x.Id != this.FBlog4);
        this.items2 = this.items2.filter((x) => x.Id != this.FBlog4);
        this.items3 = this.items3.filter((x) => x.Id != this.FBlog4);
        this.items5 = this.items5.filter((x) => x.Id != this.FBlog4);
        this.items6 = this.items6.filter((x) => x.Id != this.FBlog4);
      }
      if (this.FBlog5 != "") {
        this.items1 = this.items1.filter((x) => x.Id != this.FBlog5);
        this.items2 = this.items2.filter((x) => x.Id != this.FBlog5);
        this.items3 = this.items3.filter((x) => x.Id != this.FBlog5);
        this.items4 = this.items4.filter((x) => x.Id != this.FBlog5);
        this.items6 = this.items6.filter((x) => x.Id != this.FBlog5);
      }
      if (this.FBlog6 != "") {
        this.items1 = this.items1.filter((x) => x.Id != this.FBlog6);
        this.items2 = this.items2.filter((x) => x.Id != this.FBlog6);
        this.items3 = this.items3.filter((x) => x.Id != this.FBlog6);
        this.items5 = this.items5.filter((x) => x.Id != this.FBlog6);
        this.items4 = this.items4.filter((x) => x.Id != this.FBlog6);
      }
    },
  },
};
</script>
